<template>
    <div class="commonFormStyles pound-list">
        <HeaderNav
            header-title="磅单列表"
            left-icon-name=""
            right-icon-name=""
        ></HeaderNav>
        <div class="warpper van-pull-refresh" :style="{height: contentHeight}" :class="{ 'no_data': isActive }">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                :error.sync="error"
                :error-text="errorText"
                @load="onLoad"
            >
                <div
                    class="materialPlan-item"
                    v-for="(item) in materialPlanList"
                    :key="item.id"
                >
                    <!-- <div class="corner-marker pound-wqr" v-if="item.confirm_status===0">
                        <p class="text">
                            未确认
                        </p>
                    </div>
                    <div class="corner-marker pound-yqr" v-if="item.confirm_status===1">
                        <p class="text">
                            已确认
                        </p>
                    </div>
                    <div class="corner-marker pound-byqr" v-if="item.confirm_status===2">
                        <p class="text">
                            不予确认
                        </p>
                    </div> -->
                    <ul @click="btnClick('poundDetail',item)">
                        <li class="tit">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">过磅单编号:{{ item.balance_number }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan02"></span>
                            <span class="info">供应单编号:{{ item.task_number }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">物料名称:{{ item.type_name }}</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">物料子类:{{ item.child_type_name }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan04"></span>
                                    <span class="info">规格:{{ item.spec_name }}</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan011"></span>
                                    <span class="info">车牌号:{{ item.plate_number }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan05"></span>
                            <span class="info">接收场站:{{ item.station_name }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan07"></span>
                                    <span class="info">毛重:{{ item.gross_weight }}吨</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan07"></span>
                                    <span class="info">皮重:{{ item.tare_weight }}吨</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan07"></span>
                                    <span class="info">扣吨:{{ item.deduction_weight }}吨</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan07"></span>
                                    <span class="info">净重:{{ item.net_weight }}吨</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan08"></span>
                            <span class="info">进站时间:{{ item.gross_time }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan09"></span>
                            <span class="info">出站时间:{{ item.tare_time }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan010"></span>
                            <span class="info">快检结果:{{ item.result | resultState }}</span>
                        </li>
                    </ul>
                    <!-- <div class="btn-wrapper" v-if="item.confirm_status===0">
                        <span class="vertical-bar"></span>
                        <van-row type="flex" justify="space-around">
                            <van-col span="8">
                                <span class="btn btn_order_taking" @click="btnClick('poundDetail',item)">
                                    确认
                                </span>
                            </van-col>
                            <van-col span="8">
                                <span class="btn btn_refuse" @click="cancelClick(item)">
                                    不予确认
                                </span>
                            </van-col>
                        </van-row>
                    </div> -->
                </div>
            </van-list>
        </div>
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
export default {
    // 磅单列表
    name: 'pound-list',
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (['/affirmList', '/supplyList'].indexOf(to.path) > -1) {
            this.$store.commit('noKeepAlive', 'pound-list');
        }
        next();
    },
    data() {
        return {
            materialPlanList: [],
            loading: true,
            finished: false,
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            contentHeight: '',
            isActive: false,
            error: false,
            errorText: '',
            finishedText: '没有更多了',
        };
    },
    filters: {
        resultState(state) {
            switch (state) {
                case 0:
                    return '未检测';
                case 1:
                    return '快检通过';
                case 2:
                    return '快检通过';
                case 3:
                    return '退货';
                default:
                    return '';
            }
        },
    },
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 不予确认
        cancelClick(item) {
            Dialog.confirm({
                message: '确定要不予确认？',
            }).then(() => {
                Toast.loading({
                    message: '请求中...',
                    forbidClick: false,
                    loadingType: 'spinner',
                });
                this.$axios
                    .put('/interfaceApi/procurement/balance/confirm/' + item.id)
                    .then(() => {
                        Toast.success({
                            message: '不予确认成功',
                            duration: 500,
                        });
                        this.page.pageindex = 1;
                        this.materialPlanList = [];
                        this.getList();
                    })
                    .catch(error => {
                        this.$toast('message:' + error.ErrorCode.Message + '');
                    });
            }).catch(() => {});
        },
        btnClick(name, item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: name,
                params: {
                    row: item,
                    task_number: this.$route.params.task_number,
                },
            });
        },
        // 数据分页加载
        onLoad() {
            setTimeout(() => {
                this.page.pageindex += 1;
                this.getList();
            }, 200);
        },
        // 获取磅单列表
        getList() {
            let url = '';
            // const parentName = this.$route.params.parentName;
            // if (parentName === 'supplyList') {
            //     url = `/interfaceApi/procurement/balance/supply/${this.$route.params.task_number}?`;
            // } else {
            //     url = `/interfaceApi/procurement/balance/getpage?task_number=${this.$route.params.task_number}&`;
            // }
            url = `/interfaceApi/procurement/balance/supply/${this.$route.params.task_number}?`;
            this.$axios
                .get(`${url}pageindex=${this.page.pageindex}&pagesize=${this.page.pagesize}`)
                .then(res => {
                    this.loading = false;
                    this.materialPlanList.push(...res.rows);
                    if (this.materialPlanList.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.materialPlanList.length === 0 ) {
                        this.finishedText = '';
                        this.isActive = true;
                        this.finished = true;
                    } else {
                        this.isActive = false;
                    }
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
    },
    mounted() {
        // 获取磅单列表
        this.getList();
        this.contentHeight = document.documentElement.clientHeight - 44.8 + 'rpx';
    },
};
</script>

<style lang="stylus">
.pound-list
    padding-top 44rpx
    height calc(100% - 44rpx)
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            background #F0F0F0!important
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .warpper
        height 100%
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        padding 0 12rpx 12rpx 12rpx
        &.no_data
            background url(./../../assets/images/common/no_data.png) left center no-repeat
            background-size contain
        .materialPlan-item
            width 100%
            background #ffffff
            margin-top 15rpx
            position relative
            overflow hidden
            padding 16rpx
            color #666666
            font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.materialPlan01
                        background-image url(./../../assets/images/icons/icon_34.png)
                    &.materialPlan02
                        background-image url(./../../assets/images/icons/icon_gy_1.png)
                    &.materialPlan03
                        background-image url(./../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan04
                        background-image url(./../../assets/images/icons/icon_gy_5.png)
                    &.materialPlan05
                        background-image url(./../../assets/images/icons/icon_gy_2.png)
                    &.materialPlan06
                        background-image url(./../../assets/images/icons/icon_30.png)
                    &.materialPlan07
                        background-image url(./../../assets/images/icons/icon_gy_10.png)
                    &.materialPlan08
                        background-image url(./../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan09
                        background-image url(./../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan010
                        background-image url(./../../assets/images/icons/icon_37.png)
                    &.materialPlan011
                        background-image url(./../../assets/images/icons/icon_gy_9.png)
                .info
                    float left
                .info-bar
                    float left
                    width 125rpx
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                &.tit
                    font-size 14rpx
                    color #061F3E
            .pound-wqr
                background #FF6600
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .pound-yqr
                background #00A84B
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .pound-byqr
                background #D6010F
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .corner-marker
                width 60rpx
                height 60rpx
                position absolute
                right -30rpx
                top -30rpx
                transform rotate(45deg)
                -webkit-transform rotate(45deg)
                -moz-transform rotate(45deg)
                font-size 10rpx
                text-align center
            .btn-wrapper
                border-top 2rpx solid #F0F0F0
                padding-top 15rpx
                position relative
                .btn
                    width 100rpx
                    height 30rpx
                    line-height 30rpx
                    text-align center
                    display block
                    border-radius 4rpx
                    cursor pointer
                    &.btn_order_taking
                        background #5494F3
                        color #ffffff
                    &.btn_refuse
                        border 2rpx solid rgba(85,136,241,1)
                        color #5494F3
                        line-height 26rpx
                .vertical-bar
                    width 2rpx
                    height 15rpx
                    background rgba(215,215,215,1)
                    position absolute
                    top 50%
                    left 50%
                    margin-left -2rpx
</style>
<style>
    .materialPlan-box .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .materialPlan-box .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>
